import secrets from '../../secrets';

export const rest = props => {
  let { path, url, credentials, skipDefaultHeaders, ...options } = props;
  options = options || {};

  if (path && !url) {
    url = `${secrets.api.baseUri}/${path}`;
  }

  url = new URL(url);

  if (options.params) {
    const params = { ...options.params };

    Object.keys(params).forEach(key => {
      if (undefined === params[key] || null === params[key]) {
        delete params[key];
      }
    });

    url.search = new URLSearchParams(params).toString();
  }

  if (!options.method) { options.method = 'get' };

  if (!skipDefaultHeaders) {
    options.headers = {
      'Content-Type': 'application/json',
      Accept: '*/*',
      'access-token': credentials.accessToken,
      ...credentials,
      ...options.headers
    };
  }

  return fetch(url, options);
};
